import React, {useEffect} from "react"
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap"
import ReactApexChart from "react-apexcharts"

function MessageBox(props) {
    return (
        <>
            <div className="BLM-content" style={{border :'1px solid #ced4da',
                borderRadius: '3px',
                padding: '6px 12px',
                minHeight: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#495057'}}>
                <div className={`BLM-msgBox`} data-livenowleagueid={9999}>
                    <div className="BLM-msgBox-container">{props?.data}</div>
                </div>
            </div>
        </>
    );
}

export default MessageBox;
